import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ActivationResultComponent } from '@src/base-components/activation/steps/result/activation-result';

@Component({
    selector: 'app-activation-result-messika',
    templateUrl: './activation-result.html'
})
export class ActivationResultComponentMessika extends ActivationResultComponent { }
